export const OVERSIZED_READONLY_DELTA_CHAR_LIMIT = 5000
export const OVERSIZED_READONLY_DELTA_OP_LIMIT = 1000

function getMentionText(insert) {
    const mention = insert?.mention
    if (!mention || typeof mention !== 'object') return ''

    const denotation = mention.denotationChar || (mention.type === 'model' ? '@@' : '@')
    const label = mention.content || mention.value || mention.label || mention.id || ''
    if (!label) return ''

    const normalizedLabel =
        typeof label === 'string' && label.startsWith(denotation)
            ? label.slice(denotation.length)
            : label

    return `${denotation}${normalizedLabel}`
}

export function getDeltaSummary(deltaJson) {
    const summary = {
        chars: 0,
        lines: 0,
        ops: 0,
        hasText: false,
        hasImage: false,
        oversized: false,
    }

    if (!deltaJson) return summary

    if (typeof deltaJson === 'string') {
        summary.chars = deltaJson.length
        summary.lines = deltaJson ? Math.max(1, (deltaJson.match(/\n/g) || []).length) : 0
        summary.hasText = /\S/.test(deltaJson)
        summary.oversized = summary.chars > OVERSIZED_READONLY_DELTA_CHAR_LIMIT
        return summary
    }

    const ops = Array.isArray(deltaJson.ops) ? deltaJson.ops : []
    for (const op of ops) {
        summary.ops += 1

        if (typeof op?.insert === 'string') {
            const insert = op.insert
            summary.chars += insert.length
            summary.hasText = summary.hasText || /\S/.test(insert)
            summary.lines += (insert.match(/\n/g) || []).length
        } else if (op?.insert && typeof op.insert === 'object') {
            summary.hasImage = summary.hasImage || 'image' in op.insert
            const mentionText = getMentionText(op.insert)
            if (mentionText) {
                summary.chars += mentionText.length
                summary.hasText = true
            }
        }

        if (
            summary.chars > OVERSIZED_READONLY_DELTA_CHAR_LIMIT ||
            summary.ops > OVERSIZED_READONLY_DELTA_OP_LIMIT
        ) {
            summary.oversized = true
            break
        }
    }

    if (summary.hasText || summary.hasImage) summary.lines = Math.max(1, summary.lines)
    return summary
}
